/**
 * FavoriteType enum
 * Contains the different types of favorites that can be saved.
 */
export default class FavoriteType {
  static get Plan() {
    return this.getInstance('HomePlan');
  }

  static get Spec() {
    return this.getInstance('HomeSpec');
  }

  static get Community() {
    return this.getInstance('Community');
  }

  static get Builder() {
    return this.getInstance('Builder');
  }

  static fromKey(key) {
    const typeMap = {
      plan: FavoriteType.Plan,
      spec: FavoriteType.Spec,
      community: FavoriteType.Community,
      builder: FavoriteType.Builder,
    };
    return typeMap[key.toLowerCase()];
  }

  static getInstance(key) {
    if (!this.instances[key]) {
      this.instances[key] = new FavoriteType(key);
    }
    return this.instances[key];
  }

  constructor(type) {
    this.type = type;
  }

  toString() {
    return `${this.type}`;
  }
}

Object.defineProperty(FavoriteType, 'instances', { value: {} });
